import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { firebase } from '../notifications.config.js';
export const publicKey = firebase.publicKey;

const firebaseConfig = firebase.configs;

const app = initializeApp(firebaseConfig);

let FCMessaging = {}

async function getDeviceToken() {
	let deviceToken = null;

	const supported = await isSupported();
	if (supported) {
		const userRes = await Notification.requestPermission();
		if (userRes === 'granted') {
			FCMessaging = getMessaging(app);

			// نُسجّل ملف Firebase الصحيح بـ scope مستقل حتى لا يتعارض مع service worker الخاص بـ PWA
			const registration = await navigator.serviceWorker.register(
				'/firebase-messaging-sw.js',
				{ scope: '/firebase-cloud-messaging-push-scope' }
			);
			await getToken(
				FCMessaging,
				{
					vapidKey: publicKey,
					serviceWorkerRegistration: registration
				}
			).then((currentToken) => {
				if (currentToken) {
					deviceToken = currentToken;
				} else {
					console.log('No registration token available. Request permission to generate one.');
					alert('Please, make sure you gave the app notification permission then reload.')
					throw new Error('No notification token or permission denied')
				}
			}).catch((err) => {
				console.log('An error occurred while retrieving token. \n', err);
				alert('Please, make sure you gave the app notification permission then reload.');
				throw new Error('No notification token or permission denied')
			});
		} else {
			throw new Error('No notification token or permission denied')
		}
	}

	return deviceToken;
}

export const onGetNotification = (callBack) => {
	if (FCMessaging) {
		onMessage(FCMessaging, (payload) => {
			if (typeof callBack === 'function') {
				callBack(payload);
			}
		})
	}
};

export { getDeviceToken, isSupported as isNotificationsSupported };
export default app;